import { createContext } from 'react';

import { AsyncDataResult } from '../hooks';
import { FooterData, footerFallback, HeaderData, headerFallback, MaintenanceBannerData, ModalData } from '../models';

export interface CMSContent {
  footer: AsyncDataResult<FooterData>;
  header: AsyncDataResult<HeaderData>;
  maintenanceBanners?: AsyncDataResult<MaintenanceBannerData[]>;
  modal: AsyncDataResult<ModalData | undefined>;
}

const fallbackContext: Omit<CMSContent, 'maintenanceBanner'> = {
  footer: {
    data: footerFallback,
    isFetching: false,
    refresh: () => Promise.resolve(),
  },
  header: {
    data: headerFallback,
    isFetching: false,
    refresh: () => Promise.resolve(),
  },
  modal: {
    data: undefined,
    isFetching: false,
    refresh: () => Promise.resolve(),
  },
};

export const CMSProviderContext = createContext<CMSContent>(fallbackContext);
